import React from 'react'

import Alert from '../alert'
import {useNotifications} from './hooks'

const Notifications: React.FC = () => {
  const notifications = useNotifications()

  if (notifications.length > 0) {
    return (
      <>
        {notifications.map((n, index) => (
          <Alert key={index} severity={n.severity}>
            {n.message}
          </Alert>
        ))}
      </>
    )
  }

  return null
}

export default Notifications
